import React, { useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import LandingPage from "./page-components/components/landing-page/LandingPage";
import Welcome from "./page-components/components/welcome/Welcome";
import Doctor from "./page-components/components/doctor/Doctor";
import CreatePrescription from "./page-components/components/doctor/create-prescription/CreatePrescription";
import TemplatePreview from "./page-components/components/doctor/create-prescription/TemplatePreview";
import Settings from "./page-components/components/hip/settings/Settings";
import SlotManagementPage from "./page-components/components/slot-management";
import AdminSlotManagementPage from "./page-components/components/admin/admin-slot-management/AdminSlotManagementPage";
import PublicHandout from "./page-components/components/public/PublicHandout";
import MaintenancePage from "./page-components/components/maintenance/MaintenancePage";
import IPDManagement from "./page-components/components/ipd-management/IPDManagement";
import MedicationInventory from "./page-components/components/medication-inventory/MedicationInventory";
import AddNewRecordPage from "./page-components/components/doctor/patient-details/patient-health-records/AddNewRecordPage";
import OnlineConsultation from "./page-components/components/online-consultation/OnlineConsultation";
import CampaignManagementPage from "./page-components/components/phr-app/CampaignManagementPage";
import DoctorInformationManagementPage from "./page-components/components/phr-app/DoctorInformationManagementPage";
import HMISDoctorSlotManagementPage from "./page-components/components/phr-app/HMISDoctorSlotManagementPage";
import UserManagementPage from "./page-components/components/phr-app/UserManagementPage";
import FeatureSettingsPage from "./page-components/components/phr-app/FeatureSettingsPage";
import ProtectedRoute from "./components/ProtectedRoute";
import notificationSound from "./sounds/notificationSound.mpeg";
import { getSocket, initializeSocket } from "./page-components/utils/socket";
import { addNotification } from "./redux-store/slice/notificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentCoordinate } from "./redux-store/slice/coordinateSlice";

const Routing = () => {
  const token = localStorage.getItem("authToken");
  const dispatch = useDispatch();
  const audioRef = useRef(null);
  const currentCoordinate = useSelector((state) => state.currentCoordinate);
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  const playNotificationSound = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio(notificationSound);
    }
    audioRef.current.currentTime = 0; // Restart sound if already playing
    audioRef.current
      .play()
      .catch((err) => console.log("Audio play error:", err));
  };

  useEffect(() => {
    if (token) {
      initializeSocket(token); // Ensure socket initializes if not already
    }

    if (currentCoordinate.latitude === undefined) {
      console.log("Please connect GPS receivers");
    }

    const unlockAutoplay = new Audio();
    unlockAutoplay.src = notificationSound;
    unlockAutoplay.play().catch((err) => console.log("Autoplay error:", err));

    const socket = getSocket();
    if (socket) {
      socket.on("location", (location) => {
        // console.log(location, "location");
        if (location.latitude === undefined) {
          alert("Please connect GPS receivers");
        }
        dispatch(setCurrentCoordinate(location));
      });

      socket.on("notification", (notification) => {
        console.log("New notification received:", notification);
        dispatch(addNotification(notification));
        playNotificationSound();
      });

      return () => {
        socket.off("notification");
        socket.off("location");
      };
    }
    // eslint-disable-next-line
  }, [token, dispatch]);

  return (
    <div>
      <BrowserRouter>
        <Routes>
          {/* {isMaintenanceMode ? (
            <Route path="*" element={<MaintenancePage />} />
          ) : (
            <>
              <Route path="/" element={<LandingPage />} />
              <Route path="/doctor" element={<Doctor />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/online-consultation" element={<OnlineConsultation />} />
              <Route path="/slot-management" element={<SlotManagementPage />} />
              <Route path="/admin/slot-management" element={<AdminSlotManagementPage />} />
              <Route path="/admin/slot-management/:doctorId" element={<AdminSlotManagementPage />} />
              <Route path="/handout/:id" element={<PublicHandout />} />
              <Route
                path="/doctor/createPrescription"
                element={<CreatePrescription />}
              />
              <Route path="/templatePreview" element={<TemplatePreview />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/ipd" element={<IPDManagement />} />
              <Route path="/medication-inventory" element={<MedicationInventory />} />
              <Route path="/add-new-record" element={<AddNewRecordPage />} />
            </>
          )} */}
          {/* Active PHR App Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/campaign"
            element={
              <ProtectedRoute allowedRoles={["HOSPITALADMIN", "MARKETING_USER"]}>
                <CampaignManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/doctor-information"
            element={
              <ProtectedRoute allowedRoles={["HOSPITALADMIN", "DOCTOR", "MARKETING_USER"]}>
                <DoctorInformationManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hmis-slot-management"
            element={
              <ProtectedRoute allowedRoles={["HOSPITALADMIN", "DOCTOR", "DOCTOR_INFO_MANAGEMENT_USER"]}>
                <HMISDoctorSlotManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-management"
            element={
              <ProtectedRoute allowedRoles={["HOSPITALADMIN"]}>
                <UserManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feature-settings"
            element={
              <ProtectedRoute allowedRoles={["HOSPITALADMIN"]}>
                <FeatureSettingsPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default Routing;
